<template>
  <component
    :is="cardComponent"
    v-bind="$props"
    :competence-areas="competenceAreas"
    :is-archive="true"
    :link="advisorLink"
    :schedule="counselor.schedule"
  />
</template>

<script>
import BaseCounselorCard from 'Main/components/counselor-card/BaseCounselorCard.vue';
import CounselorCardList from 'Main/components/counselor-card/variants/CounselorCardList.vue';
import CounselorCardRoundImage from 'Main/components/counselor-card/variants/CounselorCardRoundImage.vue';
import CounselorCardTextOnImage from 'Main/components/counselor-card/variants/CounselorCardTextOnImage.vue';
import { sprintf } from 'sprintf-js';
import { mapState } from 'vuex';

export default {

  components: {
    CounselorCardList,
    CounselorCardRoundImage,
    CounselorCardTextOnImage,
  },

  computed: {
    ...mapState('counselorGrid', [
      'filteredCompetenceAreas',
      'filteredAccreditations',
      'filteredTargetGroups',
      'filteredLanguages',
      'filteredMeetingTypes',
      'filteredTitles',
      'filteredGender',
      'presetCompetence',
    ]),

    advisorLink() {
      if (this.link === '#' || !this.presetCompetence) {
        return this.link;
      }

      const urlParams = new URLSearchParams();
      urlParams.append('caseType', this.presetCompetence);

      return this.link.includes('?')
        ? `${this.link}&${urlParams.toString()}`
        : `${this.link}?${urlParams.toString()}`;
    },

    cardComponent() {
      if (this.isList) {
        return 'counselor-card-list';
      }

      if (this.isTherapist) {
        return 'counselor-card-round-image';
      }

      return 'counselor-card-text-on-image';
    },

    filteredCompetences() {
      return this.filteredCompetenceAreas
        .concat(this.filteredAccreditations)
        .concat(this.filteredTargetGroups)
        .concat(this.filteredTitles)
        .concat(this.filteredGender);
    },

    languagesString() {
      const lowercaseLanguages = this.counselor.languages
        .toLowerCase()
        .split(' ');
      const highlightedLanguages = lowercaseLanguages
        .map((language) => {
          return this.filteredLanguages
            .map((filteredLang) => filteredLang.toLowerCase())
            .includes(language)
            ? `<strong>${language}</strong>`
            : language;
        })
        .join(' ');
      return sprintf(this.texts.takesMeetingsIn, highlightedLanguages);
    },

    titleText() {
      if (
        !this.counselor.employed_since ||
        isNaN(new Date(this.counselor.employed_since).getFullYear())
      ) {
        return this.counselor.title;
      }

      const employedDate = new Date(this.counselor.employed_since);
      return `${this.counselor.title} ${this.texts.since} ${employedDate.getFullYear()}`;
    },

    useCircularImage() {
      return this.isTherapist;
    },
  },

  data() {
    return {
      currentSite: theme_vars.currentSite,
      currentSiteId: theme_vars.currentSiteId,
      texts: theme_vars.counselorSlider,
    };
  },
  extends: BaseCounselorCard,
  name: 'CounselorArchiveCard',

  props: {
    counselor: {
      required: true,
      type: Object,
    },
    isLawyer: {
      default: false,
      type: Boolean,
    },
    isList: {
      default: false,
      type: Boolean,
    },
    isTherapist: {
      default: false,
      type: Boolean,
    },
    role: {
      default: '',
      type: String,
    },
    showCompetenceAreas: {
      default: false,
      type: Boolean,
    },
    showPhoneNumber: {
      default: false,
      type: Boolean,
    },
  },
};
</script>
